module.exports = {"markup":"<span class=\"inline-clock inline-icon\"><svg width=\"11\" height=\"11\" viewBox=\"0 0 11 11\"><path d=\"M5.4 0c-3 0-5.4 2.4-5.4 5.4s2.4 5.4 5.4 5.4 5.4-2.4 5.4-5.4-2.4-5.4-5.4-5.4zm3 6.8h-3.7v-5.1h.7l.6 3.7 2.4.6v.8z\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./dev/webpack-loaders/svg-loader!./static/src/inline-svgs/icon/clock.svg
// module id = 265
// module chunks = 0 1 16